import { Paragraph } from 'ui/components/1-atoms/Paragraph/Paragraph';
import styles from './EmployeeCard.module.scss';
import { RichText } from 'ui/components/1-atoms/RichText/RichText';
import { Picture } from 'ui/components/1-atoms/Media/Picture/Picture';
import { Link } from 'ui/components/1-atoms/Action/Link/Link';

export interface EmployeeCardProps {
	id?: string;
	image?: {
		url: string;
		altText?: string;
		focalPoint?: { left: number; top: number };
	};
	name?: string;
	role?: string;
	email?: string;
	phoneNumber?: string;
	linkedIn?: { name: string; url: string };
	text?: string;
}

export const EmployeeCard: React.FC<EmployeeCardProps> = ({ id, image, name, role, email, phoneNumber, linkedIn, text }) => {
	return (
		<div className={styles.EmployeeCard} key={id}>
			{image && image.url && (
				<div className={styles.EmployeeCard_image}>
					<Picture
						url={image.url}
						altText={image.altText}
						imageCropping="cover"
						sizes="(max-width: 768px) 100vw, (max-width: 1728px) 33vw, 575px"
						focalPoint={image.focalPoint}
					/>
				</div>
			)}
			<div className={styles.EmployeeCard_info}>
				{name && <Paragraph className={styles.EmployeeCard_name}>{name}</Paragraph>}
				{role && <Paragraph>{role}</Paragraph>}
				{email && (
					<Link href={`mailto:${email}`} className={styles.EmployeeCard_email}>
						{email}
					</Link>
				)}
				{phoneNumber && <Link href={`tel:${phoneNumber}`}>{phoneNumber}</Link>}
				{linkedIn && <Link href={linkedIn.url}>{linkedIn.name}</Link>}
			</div>
			{text && <RichText className={styles.EmployeeCard_richText} content={text} />}
		</div>
	);
};
